import { Global } from '@mantine/core';

function GlobalStyles() {
	return (
		<Global
			styles={(theme) => ({
				'.mainContainer': {
					paddingTop: 25,
					paddingLeft: 35,
				},
				'.deleteButton': {
					width: 'auto',
					textAlign: 'center',
					color: '#FFFFFF',
					backgroundColor: theme.colors.red,
					borderRadius: theme.radius.sm,
					padding: '7px 8px 8px',
					lineHeight: 0,
				},
				'em-emoji-picker': {
					'--font-family': 'Montserrat, sans-serif',
					'--rgb-accent': '85, 4, 148',
				},
				'.leaflet-container': {
					width: '100%',
					height: 500,
					zIndex: 1,
				},
			})}
		/>
	);
}

export default GlobalStyles;
